import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://40c45e8614d61e7da9d44273e502325a@o4509815762321408.ingest.us.sentry.io/4511123569836032",
  sendDefaultPii: true,
  environment: document.body.dataset.sentryEnv || "unknown",
  initialScope: {
    tags: {
      showroomId: document.body.dataset.showroomId || "unknown",
      stage: document.body.dataset.sentryStage || "unknown",
    },
  },
});
